import { makeAutoObservable } from "mobx";
import { rootContainer, TYPE } from "../services/container/root";
import CanduService from "../services/candu-service";
import UserService from "../services/api/user-service";
import { CANDU_EVENTS } from "../services/candu-service";

class RmsCanduStore {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    private get _canduService(): CanduService {
        return rootContainer.get<CanduService>(TYPE.CanduService);
    }

    private get _userService(): UserService {
        return rootContainer.get<UserService>(TYPE.UserService);
    }

    async load() {
        try {
            const userIdentity = await this._userService.getCurrentPortalIdentity();
            await this._canduService.initializeCandu(userIdentity);
        } catch (e) {
            console.error('[RmsCanduStore::load] failed:', e);
        }
    }

    public trackEvent(eventName: CANDU_EVENTS): void {
        /** wrapped in try catch to make sure it will not break functionality */
        try {
            this._canduService.trackCanduEvent(eventName);
        }
        catch (e) {
            console.error('[RmsCanduStore::trackEvent] failed:', e);
        }
    }

    public renderContent(slug: string, selector: string): void {
        /** wrapped in try catch to make sure it will not break functionality */
        try {
            this._canduService.renderContent(slug, selector);
        }
        catch (e) {
            console.error('[RmsCanduStore::renderContent] failed:', e);
        }
    }
}

export default new RmsCanduStore(); 